(function() {
	'use strict';

	angular
		.module('accesso-pay')
		.factory('AccessoPayPrepService', AccessoPayPrepService);

	/**
	 * Preloads accessoPay.
	 * @param {Service} $timeout $timeout
	 * @param {Service} $q $q
	 * @param {Service} AppData AppData
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {AccessoPayPrepService} The instance
	 * @ngInject
	 */
	function AccessoPayPrepService($timeout, $q, AppData, JSONValidator, Utilities, UtilsValidation) {
		var initialized = false;
		var service = {
			getAccessoPaySDK: getAccessoPaySDK,
			loadAssetsAndSetup: loadAssetsAndSetup,
			setupAccessoPay: setupAccessoPay
		};

		return service;

		/**
		 * Returns accesso Pay SDK URL
		 * @public
		 * @memberof AccessoPayPrepService
		 * @returns {String} sdk url
		 */
		function getAccessoPaySDK() {
			var accessoPayConfig = JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay) ? JSON.parse(AppData.settings.accesso_pay) : {};
			return accessoPayConfig.sdk;
		}

		/**
		 * Loads the aPay assets
		 * @public
		 * @memberof AccessoPayPrepService
		 * @returns {undefined} undefined
		 */
		function loadAssetsAndSetup() {
			Utilities.cacheBustAndLazyLoad([
				'/scripts/modules/accesso-pay/accesso-pay-prep-service.js',
				'/scripts/modules/accesso-pay/accesso-pay-utils.js',
				'/scripts/modules/accesso-pay/accesso-pay-service.js',
				'/scripts/modules/accesso-pay/accesso-pay-payment-service.js',
				'/scripts/modules/accesso-pay/accesso-pay-controller.js',
				'/scripts/modules/accesso-pay/accesso-pay.css'
			]).then(function() {
				setupAccessoPay();
			});
		}

		/**
		 * Setup accesso pay
		 * @public
		 * @memberof AccessoPayPrepService
		 * @returns {Promise} addScriptToDocument promise
		 */
		function setupAccessoPay() {
			var sdk = null;
			if (initialized) {
				return $q.resolve();
			}

			return $q(function(resolve, reject) {
				sdk = service.getAccessoPaySDK();
				if (!UtilsValidation.validString(sdk)) {
					// no need to download assets in this case
					return $q.resolve();
				}
				Utilities
					.addScriptToDocument(service.getAccessoPaySDK(), 'accesso-pay-sdk', undefined, 1, undefined, {
						asPromise: true,
						disableReinsert: true
					}).then(function() {
						$timeout(function waitForAccessoPay() {
							if (window.accessoPay) {
								initialized = true;
								return resolve();
							}

							$timeout(waitForAccessoPay, 100);
						}, 100);
					}).catch(reject);
			});
		}
	}
}());